import { Cancel } from '@mui/icons-material';
import { AddCircle } from '@mui/icons-material';
import {
  FormControl,
  MenuItem,
  SelectChangeEvent,
  TextField,
} from '@mui/material';
import { Grid, Select } from '@mui/material';
import { IconButton } from '@mui/material';
import { InputLabel } from '@mui/material';
import { Typography } from '@mui/material';
import { DecisionNode } from 'lib/types/models';
import { Node } from 'pages/Settings/Components/Risk/Components/DecisionEngines/components/Create/types';
import React, { ChangeEvent } from 'react';

type Props = {
  newNode: Node;
  addRange: () => void;
  handleChangeRange: (e: SelectChangeEvent<number>, index: number) => void;
  deleteRange: (index: number) => void;
  availableFinalNodeForSelection: () => DecisionNode[];
};

const GTRangeAssign = (props: Props) => {
  const {
    newNode,
    addRange,
    handleChangeRange,
    deleteRange,
    availableFinalNodeForSelection,
  } = props;
  return (
    <div>
      <div
        style={{
          padding: '10px 0px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="body1" gutterBottom>
          <b>Rangos</b>
        </Typography>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <IconButton onClick={() => addRange()}>
            <AddCircle color="primary" />
          </IconButton>
        </div>
      </div>
      <Grid container spacing={2} alignItems="center" padding={'6px 0px'}>
        <Grid item xs={1}>
          <Typography>#</Typography>
        </Grid>
        <Grid item xs={7}>
          <Typography>Decisión a asignar</Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography>Valor mínimo</Typography>
        </Grid>
        <Grid item xs={1}></Grid>
      </Grid>
      {newNode.ranges.map((range, index) => (
        <Grid
          container
          spacing={2}
          key={index}
          alignItems="center"
          padding={'6px 0px'}
        >
          <Grid item xs={1}>
            <Typography>{index + 1}</Typography>
          </Grid>
          <Grid item xs={7}>
            <FormControl fullWidth variant="outlined">
              <InputLabel id="filter-label">Selecciona una decisión</InputLabel>
              <Select
                labelId="filter-label"
                id="Filtrar por estado"
                name="nodeId"
                value={range.nodeId}
                onChange={(e: SelectChangeEvent<number>) =>
                  handleChangeRange(e, index)
                }
                label="Selecciona una decisión"
              >
                {availableFinalNodeForSelection().map((x, index) => (
                  <MenuItem key={index} value={x.id}>
                    {x.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={3}>
            {0 === index ? (
              <Typography padding={'8px'} variant="body1" gutterBottom>
                - ∞
              </Typography>
            ) : (
              <TextField
                label="Valor máximo"
                variant="outlined"
                type="number"
                fullWidth
                value={range.value}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  handleChangeRange(e, index)
                }
                name="value"
              />
            )}
          </Grid>

          <Grid item xs={1}>
            <IconButton
              disabled={0 === index}
              onClick={() => deleteRange(index)}
            >
              <Cancel />
            </IconButton>
          </Grid>
        </Grid>
      ))}
    </div>
  );
};

export default GTRangeAssign;
